// src/components/products/ProductList.jsx
import React from "react";
import ProductCard from "./ProductCard";

const ProductList = ({ items, safeText, sectionTitle }) => {
  if (!items || items.length === 0) {
    return (
      <div className="py-10 text-center text-gray-500">
        No products available for this brand yet.
      </div>
    );
  }

  return (
    <section className="products-list-section" aria-label={sectionTitle || "Products"}>
      {sectionTitle && (
        <header className="products-list-section-header mb-5 sm:mb-7 pt-6 sm:pt-8">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold product-heading">
            {sectionTitle}
          </h2>
        </header>
      )}
      <div className="space-y-6 sm:space-y-8">
        {items.map((item, index) => (
          <ProductCard
            key={item.id || index}
            item={item}
            index={index}
            safeText={safeText}
          />
        ))}
      </div>
    </section>
  );
};

export default ProductList;
